import React from "react";
import { db } from "../../../../firebase";
import { addDoc, collection } from "firebase/firestore";

const TestAccessory = () => {
  const addTestData = async () => {
    try {
      const testAccessory = {
        itemCode: "MSK-RSM-001",
        category: "Mask",
        itemName: "ResMed AirFit N20 Nasal Mask",
        brand: "ResMed",
        model: "AirFit N20",
        size: "M",
        unitPrice: 2500,
        stockQuantity: 15,
        minimumStock: 5,
        vendor: "SaintMed",
        incomingDate: new Date(),
        expiryDate: null,
        location: "Shelf A-1",
        status: "Active",
        note: "Test accessory item",
        createdAt: new Date(),
        createdBy: "Test User",
        updatedAt: new Date(),
        updatedBy: "Test User",
      };

      await addDoc(collection(db, "accessories"), testAccessory);
      alert("Test accessory added successfully!");
    } catch (error) {
      console.error("Error adding test accessory:", error);
      alert("Error: " + error.message);
    }
  };

  return (
    <div className="p-3">
      <h4>Test Accessories Collection</h4>
      <button className="btn btn-primary" onClick={addTestData}>
        Add Test Accessory
      </button>
    </div>
  );
};

export default TestAccessory;